/**
 * <gwp-banner data-end="<epoch ms>">
 *
 * Client-side companion to snippets/product-gwp-banner.liquid.
 *  - Ticks the optional [data-gwp-countdown] badge from the visitor's current time to data-end.
 *  - Hides the whole banner once data-end passes, so a cached page never keeps showing an expired offer.
 */
if (!customElements.get('gwp-banner')) {
	customElements.define(
		'gwp-banner',
		class GwpBanner extends HTMLElement {
			connectedCallback() {
				// The script runs before the browser has parsed this element's children,
				// so wait for the document to finish parsing before looking them up.
				if (document.readyState === 'loading') {
					document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
				} else {
					this.init();
				}
			}

			init() {
				if (!this.isConnected) return;
				this.stop();
				this.end = parseInt(this.dataset.end, 10);
				if (Number.isNaN(this.end)) return;

				this.countdown = this.querySelector('[data-gwp-countdown]');
				this.value = this.querySelector('[data-gwp-countdown-value]');

				if (this.tick()) {
					this.interval = setInterval(() => {
						if (!this.tick()) this.stop();
					}, 1000);
				}
			}

			disconnectedCallback() {
				this.stop();
			}

			stop() {
				clearInterval(this.interval);
			}

			/** @returns {boolean} true while the offer is still running */
			tick() {
				const remaining = this.end - Date.now();

				if (remaining <= 0) {
					this.hidden = true;
					return false;
				}

				if (this.countdown && this.value) {
					this.value.textContent = this.format(remaining);
					this.countdown.hidden = false;
				}
				return true;
			}

			format(ms) {
				const total = Math.floor(ms / 1000);
				const days = Math.floor(total / 86400);
				const hours = Math.floor((total % 86400) / 3600);
				const minutes = Math.floor((total % 3600) / 60);
				const seconds = total % 60;
				const pad = (n) => String(n).padStart(2, '0');

				const time = `${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
				return days > 0 ? `${days}d ${time}` : time;
			}
		},
	);
}
